<div class="date-range">
  <h2 class="date-range__title">Custom date range</h2>

  <div class="date-range__fields">
    <button
      type="button"
      class="date-range__field pendo-date-range-start"
      [class.date-range__field--active]="activeStep === 'start'"
      (click)="resetSelection()"
    >
      <span class="date-range__field-label">Start date</span>
      <span
        class="date-range__field-value"
        [class.date-range__field-value--empty]="!range.start"
        >{{ startLabel }}</span
      >
    </button>

    <mat-icon class="date-range__arrow">arrow_forward</mat-icon>

    <button
      type="button"
      class="date-range__field"
      [class.date-range__field--active]="activeStep === 'end'"
      [disabled]="!range.start"
      (click)="resetEnd()"
    >
      <span class="date-range__field-label">End date</span>
      <span
        class="date-range__field-value"
        [class.date-range__field-value--empty]="!range.end"
        >{{ endLabel }}</span
      >
    </button>
  </div>

  <div class="date-range__calendars">
    <mat-calendar
      class="date-range__calendar"
      [startAt]="leftStartAt"
      [selected]="range"
      [minDate]="minDate"
      [maxDate]="maxDate"
      (selectedChange)="onDateSelected($event)"
    ></mat-calendar>
    <mat-calendar
      class="date-range__calendar"
      [startAt]="rightStartAt"
      [selected]="range"
      [minDate]="minDate"
      [maxDate]="maxDate"
      (selectedChange)="onDateSelected($event)"
    ></mat-calendar>
  </div>

  <div class="date-range__footer">
    <span
      class="date-range__hint"
      *ngIf="hint"
      [class.date-range__hint--error]="invalidReason"
      >{{ hint }}</span
    >
    <button
      type="button"
      class="date-range__apply pendo-date-range-apply"
      [disabled]="!canApply"
      (click)="apply()"
    >
      Apply
    </button>
  </div>
</div>
